import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../ui/Footer';
import Logo from '../../components/assets/logo/logo';

const resetPassword = () =>{
    return (
        <div>
            <Link to={"/"}><Logo/></Link>
            <h1>Reset Password</h1>

            <form>
            <div className="input-container">
                    <label>Email address</label>
                    <input type="email" className="form-control" placeholder="Enter Your Email" />
            </div>

            <div className="input-container">
                <label>Old address</label>
                <input type="password" className="form-control" placeholder="Enter Your Old Password" />
            </div>

            <div className="input-container">
                <label>New Password</label>
                <input type="password" className="form-control" placeholder="Enter Your New Password" />
            </div>

            <div className="input-container">
                <label>Confirm Password</label>
                <input type="password" className="form-control" placeholder="Confirm Your New Password" />
            </div>

            <button type="submit" className="submit">Reset</button>

            </form>

            <Footer />
        </div>
    )

}

export default resetPassword;